import React from "react";
import { FaCheckCircle, FaCloud, FaExclamationTriangle } from "react-icons/fa";
import { Container, Image } from "react-bootstrap";
import { TimedProgressBar, usePlayer } from "pages/player";
import { FormattedMessage } from "react-intl";

import logo from "common/assets/logo_gmetrix.png";

const STATES = {
    CONNECTING: 0,
    CONNECTED: 1,
    DISCONNECTED: 2,
    FAILED: 3
};

export const ConnectionStatus = props => {

    const { connection_state, avg_load_time, max_load_time } = usePlayer();

    const Icon = () => {

        switch (connection_state){
            case STATES.DISCONNECTED:
                return (
                    <FaCheckCircle size={50} className="text-info"/>
                );
            case STATES.FAILED:
                return (
                    <FaExclamationTriangle size={50}/>
                );
            default:
                return <></>;
        }

    };

    const Message = () => {
        switch (connection_state){
            case STATES.DISCONNECTED:
                return (
                    <>
                        <FormattedMessage
                            id="label.your_session_has_ended"
                            defaultMessage="Your session has ended."
                    />
                        <br/>
                        <FormattedMessage
                            id="label.thank_you_for_using_gmetrix_cloud"
                            defaultMessage="Thank you for using GMetrix Cloud."
                    />
                    </>
                );
            case STATES.FAILED:
                return (
                    <FormattedMessage
                        id="label.we_were_unable_to_start_your_cloud.8f16abff"
                        defaultMessage="We were unable to start your cloud testing session due to an unexpected error"
                    />
                );
            default:
                return <></>;
        }
    };

    return (
        <Container fluid className="d-flex justify-content-center align-items-center min-vh-100">
            <div
                className="text-center d-flex flex-column gap-5"
                style={{
                    maxWidth: connection_state === STATES.CONNECTING ? 350 : 375
                }}
            >
                <div className="d-flex gap-3 justify-content-center align-items-center">
                    <FaCloud size={55} className="text-secondary"/>
                    <Image src={logo} width={200}/>
                </div>

                {connection_state === STATES.CONNECTING ?
                    (
                        <>
                            {/* Don't initialize the progress bar until we have an estimated load time */}
                            {avg_load_time && <TimedProgressBar duration={avg_load_time} />}
                        </>

                    )
                    :
                    (
                        <div className={`d-flex flex-column align-items-center gap-5 ${connection_state === STATES.FAILED ? "text-danger" : ""}`}>

                            <Icon />

                            <h5 className="m-0">
                                <Message/>
                            </h5>
                        </div>
                    )
                }

            </div>
        </Container>
    );

};